import { render, staticRenderFns } from "./committee-modal.vue?vue&type=template&id=247bf744&scoped=true&"
import script from "./committee-modal.vue?vue&type=script&lang=js&"
export * from "./committee-modal.vue?vue&type=script&lang=js&"
import style0 from "./committee-modal.vue?vue&type=style&index=0&id=247bf744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247bf744",
  null
  
)

export default component.exports